import { useUrlSearchParams } from '@vueuse/core';
import { useSessionStorage } from '@src/utils/storage';

interface FormAppInfo {
    formAppName?: string | null;
    targetMapId?: string | null;
}

const formAppInfo = useSessionStorage<FormAppInfo>('formAppInfo', {});
const urlParams = useUrlSearchParams('history');

/** 从 URL 查询参数中获取指定 key 的值 */
export function getUrlParamsByKey(key: string) {
    const value = urlParams[key];
    return value == null || value === '' ? null : String(value);
}

/** 通过 URL 参数写入 sessionStorage，并清除地址栏中的外链参数（保留 token 等其它 query） */
export function setStoreByUrlParams() {
    const formAppName = getUrlParamsByKey('formAppName');
    if (!formAppName) return; // 非外链模式直接返回

    formAppInfo.value = {
        formAppName,
        targetMapId: getUrlParamsByKey('targetMapId'),
    };

    // 移除 URL 参数
    delete urlParams.formAppName;
    delete urlParams.targetMapId;
}

/** 获取外部应用传递的来源信息（优先 sessionStorage，回退 URL 参数） */
export function getFormAppInfo() {
    return {
        formAppName: formAppInfo.value.formAppName || getUrlParamsByKey('formAppName'),
        targetMapId: formAppInfo.value.targetMapId || getUrlParamsByKey('targetMapId'),
    };
}

/** 是否来自「微观E家」桌面端（Electron 环境） */
export function isFromCrmFamily() {
    return getFormAppInfo()?.formAppName === 'crmFamily' && !!(window as any).ipcRenderer;
}

/** 是否来自「微观世界」手机端 */
export function isFromCrmMobile() {
    return getFormAppInfo()?.formAppName === 'crmMobile';
}
